import { Button, Stack } from '@mui/material';
import { useContext } from 'react';
import { useTranslation } from 'react-i18next';

import { RecommendationFormContext } from '../RecommendationFormProvider/RecommendationFormProvider.context';
import { I18nNamespace } from '~/common/types';

interface DemandRecommendationActionsProps {
  isFormDirty: boolean;
  isLoading: boolean;
  onDiscardChanges: () => void;
}

export const DemandRecommendationActions = ({
  isFormDirty,
  isLoading,
  onDiscardChanges,
}: DemandRecommendationActionsProps) => {
  const { isFormActive } = useContext(RecommendationFormContext);
  const { t } = useTranslation(I18nNamespace.widgets, { keyPrefix: 'DemandRecommendationWidget' });

  return (
    <Stack
      direction="row"
      spacing={2}
      sx={{
        alignItems: 'center',
      }}
    >
      <Button disabled={!isFormDirty || !isFormActive} onClick={onDiscardChanges}>
        {t('discardChanges')}
      </Button>
      <Button
        variant="contained"
        disabled={!isFormDirty || isLoading}
        type="submit"
        loading={isLoading}
        color="primary"
      >
        {t('applyChanges')}
      </Button>
    </Stack>
  );
};
